import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const OctapharmaEndOfMonthInventorySourcePage = () => {
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const history = useHistory();
    /** if change file name here need to change in excelUtility file */
    const fileName = 'Octapharma End Of Month Inventory Source';
    const [salesSource, setSalesSource] = useState([]);
    const [loading, setLoading] = useState(false);

    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    // excel Headers
    const excelColumns = [

        {
            Header: "PRODUCT",
            accessor: "ProductName",
            filter: "ProductName",
            sortType: "basic",
            width:300,
        },
        {
            Header: "NDC",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
            width:120,
        },
        {
            Header: "LOT",
            accessor: "LotNumber",
            filter: "LotNumber",
            sortType: "basic",
            width:115,
        },
       
        {
            Header: "EXPIRATION",
            accessor: "ExpirationDate",
            filter: "ExpirationDate",
            sortType: "basic",
            width:115,
        },
        {
            Header: "VIALS",
            accessor: "AvailableQuantity",
            filter: "AvailableQuantity",
            sortType: "basic",
            width:80,
        },
        {
            Header: "IU/VIAL",
            accessor: "UnitsOrVial",
            filter: "UnitsOrVial",
            sortType: "basic",
            width:95,
        },
        {
            Header: "TOTAL IU",
            accessor: "TotalUnit",
            filter: "TotalUnit",
            sortType: "basic",
            width:100,
        },
        {
            Header: "End of Month Inventory",
            accessor: "EndofMonthInventory",
            filter: "EndofMonthInventory",
            sortType: "basic",
            width:220,
        },
       
    ];
    //
    useEffect(() => {
        getServiceFee();
    }, [])
    async function getServiceFee() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`;
        await _HttpServices
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=1489=${outbounddata.File_Process_ID}`)
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=${outbounddata.File_Process_ID}`)
            .getData(url)
            .then((data) => {
                const serviceFeeResult = data.data;
                if (serviceFeeResult.length > 0) {
                    serviceFeeResult.map((res) => {
                        res.ExpirationDate = moment(res.ExpirationDate).format('MM/DD/YYYY');
                        // res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');                          
                        // res.AcquisitionCost = res.AcquisitionCost == null ? "$0.00" :"$"+ (res.AcquisitionCost * 1).toFixed(2);
                        // res.ContractPrice = res.ContractPrice == null ? "$0.00" :"$"+ (res.ContractPrice * 1).toFixed(2);
                        // res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" :"$"+ (res.CIBDExtendedAmount * 1).toFixed(2)
                        // res.SaleQTY = res.SaleQTY == null? "0.0000":  (res.SaleQTY*1).toFixed(4);
                        // res.DosagORUnitstabs30 = res.DosagORUnitstabs30 == null? "0.0000":  (res.DosagORUnitstabs30*1).toFixed(4);
                        // res.Totalcount = res.Totalcount == null? "0.0000":  (res.Totalcount*1).toFixed(4);
                    })
                }
                setSalesSource(serviceFeeResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });

    }
    async function headerData(salesSource) {
        var data_to_download = []
        if(salesSource.length != 0){
        salesSource.map((data, pidex) => {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = salesSource[pidex][excelColumns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })}
        else {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = ""
            })
            data_to_download.push(record_to_download)
        }
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Sales Source Data");
    }
    const EditRecords = () =>{
        localStorage.setItem("salesSource",JSON.stringify(salesSource));
        history.push("/OctapharmaInventoryEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Octapharma End Of Month Inventory Source</h2>
                {loading ? <Loader /> : null}
                <div>
                {salesSource.length > 0 && (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,salesSource,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
             {/* Toaster */}
             {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Octapharma End Of Month Inventory Source.</p> :
                                <Fragment>
                                    {salesSource.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={salesSource} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default OctapharmaEndOfMonthInventorySourcePage;